<template>
    <div>
        <!-- Modal -->
        <b-modal id="NonVisitorDocumentModal" title="Correos que no han visto el documento" size="xl" centered scrollable
            header-bg-variant="dark" v-model="modalShow">

            <template #modal-header="{ close }">
                <!-- Emulate built in modal header close button action -->
                <b-button size="sm" variant="outline-warning" @click="close()">
                    Cerrar
                </b-button>

            </template>

            <AlertDismiss class="mx-2" ref="alertDismiss"></AlertDismiss>

            <!-- cuerpo de cart -->
            <DocumentNonVisitorTable :documentId="documentId"></DocumentNonVisitorTable>

            <!-- fooder -->
            <template #modal-footer>
                <div class="w-100">

                </div>
            </template>

        </b-modal>
    </div>
</template>
<script>
import AlertDismiss from '@/components/shared/Alert-dismiss.vue'
import { EventNames } from '@/plugins/enums/index.js'

import DocumentNonVisitorTable from '@/components/DocumentRepository/DocumentNonVisitors/Document-non-visitor-table.vue'

export default {
    name: 'DocumentNonVisitors',

    data() {
        return {
            modalShow: false,
            documentId: ''
        }
    },

    components: {
        AlertDismiss,
        DocumentNonVisitorTable
    },

    async mounted() {
        this.$eventBus.$on(EventNames.OpenModalDocumentNonVisitors, async (query) => {
            this.documentId = query[0].id;
            this.openModal();
        });
    },

    methods: {
        openModal() {
            this.modalShow = true;
        },

        closeModal() {
            this.modalShow = false;
        }
    }

}
</script>
<style></style>